import {
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Invoice } from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useHistory } from "react-router-dom";
import { selectorCounterpartyDisplayName } from "../../shared/selectors/selectorCounterpartyDisplayName";

type Props = {
  invoice: Invoice;
};

export const InvoiceSplits: React.FC<Props> = ({ invoice }) => {
  const history = useHistory();

  return (
    <WSList>
      {(invoice.splits ?? []).map(split => {
        if (!split.payee) {
          return null;
        }

        const payeeName = selectorCounterpartyDisplayName(split.payee);

        return (
          <WSFlexBox.CenterY
            key={split.id ?? split.payeeId}
            wrap="nowrap"
            onClick={
              split.payableId
                ? () => {
                    history.push(
                      `/member/invoices/payables/all/${split.payableId}`
                    );
                  }
                : undefined
            }
          >
            <WSAvatar.Text text={payeeName} mr="M" />
            <WSElement style={{ flex: 1 }}>
              <WSText mb="XS">{payeeName}</WSText>
              <WSText.ParagraphXs color="gray600">
                {split.description}
              </WSText.ParagraphXs>
            </WSElement>
            <WSText>
              {formatMoney(split.amount ?? 0, invoice.currency || "USD")}
            </WSText>
          </WSFlexBox.CenterY>
        );
      })}
    </WSList>
  );
};
